import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import versionInfo from './version.json';

// Print build and version information in console
console.log(
  `%c Spent App %c v${versionInfo.version} (Build #${versionInfo.buildNumber}) %c ${versionInfo.gitBranch}@${versionInfo.gitCommit} • ${versionInfo.buildDate}`,
  'background: #2563eb; color: #fff; padding: 2px 6px; border-radius: 4px 0 0 4px; font-weight: bold;',
  'background: #10b981; color: #fff; padding: 2px 6px; font-weight: bold;',
  'background: #374151; color: #9ca3af; padding: 2px 6px; border-radius: 0 4px 4px 0;'
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

